import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { MARKET_GROUP_TYPES, TABLE_BOX_TYPES } from '../../enums/betTypesEnum';
import { doBetStore } from '../../store/doBetStore';
import { CurrentBoxInfo } from '../currentBoxInfo';
import { gameStore } from '../../store/gameStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';

export const BoxBetsAndCards = observer(() => {
  const { selectedChip, updateBetsModel, handleNotificationCode, lastBetModel } = doBetStore;
  const { roundBetsByPhase, roundBetTypesInfo } = gameStore;
  const { activeFreeBet } = freeBetStore;

  const totalAmountByBetType = useMemo(() => {
    if (roundBetsByPhase) {
      return Object.keys(roundBetsByPhase)
        .reduce((arr, current) => {
          arr = [...arr, ...roundBetsByPhase[current]];
          return arr;
        }, [])
        .reduce((acc, cur) => {
          const marketType = cur.betData?.hasOwnProperty('marketType')
            ? cur.betData?.marketType
            : cur.betData?.markets?.marketType;

          if (!acc[marketType]) {
            acc[marketType] = cur.amount;
          } else {
            acc[marketType] += cur.amount;
          }
          return acc;
        }, {});
    }
    return null;
  }, [roundBetsByPhase]);

  const handleDoChip = useCallback(
    ({ betType }) => {
      if (
        activeFreeBet.id &&
        lastBetModel.betModel &&
        activeFreeBet.remainingCount - lastBetModel.betModel.length === 0
      ) {
        handleNotificationCode(betResponseCodeByName.NotFreeChip);
        return;
      }
      updateBetsModel({
        marketType: betType,
        groupType: MARKET_GROUP_TYPES.WinningBox,
        amount: selectedChip,
      });
    },
    [handleNotificationCode, activeFreeBet, lastBetModel.betModel, selectedChip, updateBetsModel]
  );

  const boxBetTypesInfo = useMemo(() => {
    if (roundBetTypesInfo) {
      return roundBetTypesInfo.find((item) => item.groupType === MARKET_GROUP_TYPES.WinningBox);
    }
    return null;
  }, [roundBetTypesInfo]);

  return (
    <div className='bet-on-poker-seats'>
      {TABLE_BOX_TYPES.map((betType, index) => (
        <CurrentBoxInfo
          key={betType}
          betType={betType}
          handleDoChip={handleDoChip}
          boxBetTypesInfo={boxBetTypesInfo}
          totalAmount={totalAmountByBetType?.[betType]}
          boxIndex={index + 1}
        />
      ))}
    </div>
  );
});
